export const RESPONSIBILITY_STATEMENT = {
    title: '免责声明&风险提示',
    protocols: [
        {
            list: [
                { text: '第一条：本平台按照《上海屋聚网络平台用户使用协议》与《上海屋聚平台服务协议》，通过线上形式审核的方式初步确认双方的签约主体资质与房源信息，为双方达成租赁关系提供信息渠道并提供房屋租赁合同范本和电子文本留存服务。' },
                { text: '第二条：本平台旨在提供用户一个信息发布交易的开放式平台，不参与线上用户具体的信息发布与交易行为。所有房源信息均由线上用户提供。本平台对出/承租双方的主体信息真实性、房源信息真实性、出租方是否真正具备出租权利等不作保证，建议线上用户通过线下自行联系并甄别信息真伪，避免上当受骗，由此产生的法律纠纷和经济损失与本平台无涉。' },
                { text: '第三条：用户在本平台上发布信息和使用服务，应当遵守法律法规和政府规定，不得侵犯其他人的合法权利，且不得通过本平台或者其他途径进行有损于本平台的行为。如果因用户发布信息而收到主张权利的声明，为避免引起纠纷，本平台有权删除相关信息。违反以上规则对本平台造成损害的，我们保留对其追究法律责任的权利。' },
                { text: '第四条：任何由于黑客攻击、计算机病毒侵入或发作等归责于第三方的事件，亦或是因政府管制、司法机关调查而造成的暂时性关闭等影响网络正常经营的政治司法因素，以及因火灾台风灾害等不可抗力导致平台无法正常运营，进而导致用户权益受损的，本平台均得免责。' },
                { text: '第五条：本平台因正常的系统维护、升级，或因网络拥塞而导致平台暂时不能访问的，不承担任何责任；若因线路及非本公司控制范围外的硬件故障或其它不可抗力而导致暂停服务的， 于暂停服务期间造成的一切不便与损失，本平台均得免责。' },
                { text: '第六条：本平台建议承租人通过线下沟通先予确认甲方是否具备出租本协议项下房屋的权利，具体确认方式请参考本平台房屋租赁法律小贴士相关内容。  ' }
            ]
        },
    ]
}